import { twMerge } from 'tailwind-merge';

import { IBoundary } from '@domain/regulations/hooks/useRegulationBoundaryAtLocation';
import { ICoordinates } from '@app-types/geo';
import { Heading } from '../Heading/Heading';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

import { RegulationLocationContent } from './RegulationLocationContent';
import { ChangeLocation } from '../ChangeLocation/ChangeLocation';

interface ICoordinateProps {
  coordinates: ICoordinates | undefined;
  boundaryName: string | undefined;
  boundaries: IBoundary[] | undefined;
  isLoadingBoundaries?: boolean;
  fishrulesSpeciesId: number | undefined;
  className?: string;
}

export const RegulationLocationCard = ({
  coordinates,
  boundaryName,
  boundaries,
  isLoadingBoundaries,
  fishrulesSpeciesId,
  className,
}: ICoordinateProps) => (
  <div
    className={twMerge(
      `flex flex-col justify-between rounded-md bg-white sm:flex-row sm:items-center`,
      className,
    )}
  >
    {isLoadingBoundaries ? (
      <LoadingSpinner className="m-0 w-full p-4" loadingText="Loading boundaries..." />
    ) : (
      <>
        <div className="p-4 md:p-8">
          <Heading variant="2xs">Regulations for</Heading>
          <RegulationLocationContent
            coordinates={coordinates}
            boundaryName={boundaryName}
            boundaries={boundaries}
          />
        </div>
        <ChangeLocation
          coordinates={coordinates!}
          fishrulesSpeciesId={fishrulesSpeciesId}
          eventSource="regulation-location"
        />
      </>
    )}
  </div>
);
